/**
 * QuickMessagesButton — dispara mensagens prontas da operação no chat da OS.
 *
 * Lista apenas as mensagens marcadas como "Usuário (web)" ou "Ambos" no
 * cadastro (Config › Mobile › Mensagens Prontas). Clique envia na hora.
 */
import { useCallback, useEffect, useState } from "react";
import { MessageSquareText, Loader2 } from "lucide-react";
import api from "../utils/api";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const QuickMessagesButton = ({ serviceId, onPick, disabled }) => {
  const [open, setOpen] = useState(false);
  const [itens, setItens] = useState(null);

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get("/quick-messages/for-chat", { params: { service_id: serviceId } });
      setItens(data?.items || []);
    } catch {
      setItens([]);
    }
  }, [serviceId]);

  useEffect(() => {
    if (open && itens === null) carregar();
  }, [open, itens, carregar]);

  if (!serviceId) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="shrink-0"
          disabled={disabled}
          title="Mensagens prontas da operação"
          data-testid="chat-quick-messages-btn"
        >
          <MessageSquareText className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" side="top" /* Acima do drawer do chat global (z-1700) e dos overlays do mapa. */
        className="w-80 p-0 !z-[1800]" data-testid="chat-quick-messages-popover">
        <div className="max-h-72 overflow-y-auto py-1">
          {itens === null && (
            <div className="flex items-center gap-2 px-3 py-3 text-xs text-gray-400">
              <Loader2 className="h-3.5 w-3.5 animate-spin" /> Carregando…
            </div>
          )}
          {itens?.length === 0 && (
            <p className="px-3 py-3 text-xs text-gray-400">
              Nenhuma mensagem liberada para a operação neste tipo de serviço.
            </p>
          )}
          {(itens || []).map((m) => (
            <button
              key={m.id}
              type="button"
              onClick={() => {
                setOpen(false);
                onPick?.(m.mensagem);
              }}
              className="w-full text-left px-3 py-2 hover:bg-gray-50 transition-colors"
              data-testid={`chat-quick-message-${m.id}`}
            >
              <span className="block text-[13px] font-semibold text-gray-800">{m.nome}</span>
              <span className="block text-[11px] text-gray-500 line-clamp-2">{m.mensagem}</span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default QuickMessagesButton;
